import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from 'moment'
import CallMergeIcon from '@material-ui/icons/CallMerge';
import {Tooltip} from "@material-ui/core";
import {confirmAlert} from "react-confirm-alert";
import APPCONFIG from "../../constants/Config";
import AutorenewIcon from "@material-ui/icons/Autorenew";


export default class StripeCharges extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
	}

	mergeEntries = async (pkey, license) => {
		if (!pkey) {
			alert("Missing AV Key.")
			return;
		}
		if (license) {
			confirmAlert({
				title: 'Confirm Key Reassign',
				message: 'This will assign a NEW key to this customer and the old key will be deleted. Are you sure you want to do this?',
				buttons: [
					{
						label: 'Yes',
						color: 'danger',
						onClick: async () => {
							let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.CREATE);
							model.object.pkey = pkey;
							await model.submit(null, 'POST_MARK_USED');
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		} else {
			let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.CREATE);
			model.object.pkey = pkey;
			await model.submit(null, 'POST_MARK_USED');
		}
	}

	handleLinkRegeneration = async (customer, av_key) => {
		let av_model = new API.BuildClass(Types.Av_Links._name, API.RequestType.UPDATE);
		av_model.object.customer = customer;
		av_model.object.av_pkey = av_key;
		await av_model.submit(null, 'POST_REGENERATE_LINK');
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =
			this.props.isFE ? [
				{
					Header: "Customer",
					id: "customers.name",
					Cell: props => {
								return (
									<span>
										<Link to={`/customers/${props.original.customer}`} target={"_blank"}>
											{props.original.customer_name}
										</Link>
									</span>
								);
							}
				},
				{
					Header: "Product",
					id: "product_name",
					accessor: obj => (obj.product_name)
				},
				{
					Header: "Key",
					id: "av_keys.activation_key",
					/** @param {Stripe_Charges_Object} obj */
					accessor: obj => {
						return obj.av_keys ? obj.av_keys.activation_key : 'N/A'
					}
				}
			] : [
				{
					Header: "Customer",
					id: "customers.name",
					Cell: props => {
						return (
							<span>
								<Link to={`/customers/${props.original.customer}`} target={"_blank"}>
									{props.original.customer_name}
								</Link>
							</span>
						);
					}
				},
				{
					Header: "Billed Amount",
					id: "amount",
					accessor: obj => (obj.amount)
				},
				{
					Header: "Product",
					id: "product_name",
					accessor: obj => (obj.product_name)
				},
				{
					Header: "Sold Date",
					id: "created",
					/** @param {Av_Keys_Object} obj */
					accessor: obj => {
						return obj.created ? moment.parseZone(obj.created).format("MM/DD/YYYY") : 'N/A'
					}
				},
				{
					Header: "Key",
					id: "av_keys.activation_key",
					/** @param {Stripe_Charges_Object} obj */
					accessor: obj => {
						return obj.av_keys ? obj.av_keys.activation_key : 'N/A'
					}
				},
	{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								{this.props.showMergeButton && props.original.av_keys ? <Tooltip title={!!props.original.av_keys?.activation_key ? "This customer already has a key, clicking this will assign him a new key." : "Assign an unused key to this customer."} arrow>
									<Button color="info" size={"sm"} block={true} onClick={async () => {await this.mergeEntries(props.original.av_keys?.pkey, props.original.av_keys?.activation_key)}}>
										<CallMergeIcon fontSize={'small'}/>
									</Button>
								</Tooltip> : null}
							</span>
						);
					}
				}
			]

		if (this.props.showMergeButton) {
			//let them regenerate the link (basically just makes it active again for the next hour)
			columns.push({
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
return (
						<span>
							{this.props.showMergeButton && props.original.stripe_product.includes("BitDefender") ? <Tooltip title={"This will refresh the BitDefender link to expire 1 hour from now."} arrow>
								<Button color="info" size={"sm"} block={true} onClick={async () => this.handleLinkRegeneration(props.original.customer, props.original.av_key)}>
									<AutorenewIcon fontSize={'small'}/>
								</Button>
							</Tooltip> : null}
						</span>
					);
				}
			})
		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Payments')}
							{this.renderHeaderRight("Payments",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSizeOptions={[5, 10, 15, 20, 50]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
